export default __webpack_public_path__ + "static/media/bridge.4ed30f63.JPG";